module.exports = __webpack_public_path__ + "img/161.gaming_consoles.672dcc84.svg";